export const unique = (val, i, list) => list.indexOf(val) === i;
export const orderBy = key => (a, b) => a[key] - b[key];
export const removedItems = (a = [], b = []) => {
    return a.reduce((removed, aa) => {
        if (!b.includes(aa)) {
            removed.push(aa);
        }

        return removed;
    }, []);
};

export const collect = (...list) => item => list.reduce((col, key) => {
    col[key] = item[key];
    return col;
}, {});

export const notEmpty = e => !!e;
export const randomOrder = () => Math.random() - 0.5;
export const orderSpecifically = (list = [], ordering = []) => {
    const detachedList = [...list];
    
    return (a,b) => {
        const indexA = detachedList.indexOf(a);
        const indexB = detachedList.indexOf(b);

        return ordering.indexOf(indexA) - ordering.indexOf(indexB);
    }
}

// determines if all of the items in list B are found in list A
export const allFound = (arrA = [], arrB = []) => (
    arrB.reduce((found, item) => (
        found && arrA.includes(item)
    ), true)
)

export const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

export const alphabeticOrdinal = index => ALPHABET.charAt(index);